export const CLEAR_TRANSACTION = 'CLEAR_TRANSACTION';
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS';
export const CLEAR_STATE = 'CLEAR_STATE';

export const DELETE_TRANSACTION = 'DELETE_TRANSACTION';
export const DELETE_TRANSACTION_ERROR = 'DELETE_TRANSACTION_ERROR';
export const DELETE_TRANSACTION_SUCCESS = 'DELETE_TRANSACTION_SUCCESS';

export const DOWNLOAD_TRANSACTIONS = 'DOWNLOAD_TRANSACTIONS';
export const DOWNLOAD_TRANSACTIONS_ERROR = 'DOWNLOAD_TRANSACTIONS_ERROR';
export const DOWNLOAD_TRANSACTIONS_SUCCESS = 'DOWNLOAD_TRANSACTIONS_SUCCESS';

export const GET_ALL_TRANSACTIONS = 'GET_ALL_TRANSACTIONS';
export const GET_ALL_TRANSACTIONS_ERROR = 'GET_ALL_TRANSACTIONS_ERROR';
export const GET_ALL_TRANSACTIONS_SUCCESS = 'GET_ALL_TRANSACTIONS_SUCCESS';

export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const GET_TRANSACTIONS_ERROR = 'GET_TRANSACTIONS_ERROR';
export const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';

export const GET_INVOICE = 'GET_INVOICE';
export const GET_INVOICE_ERROR = 'GET_INVOICE_ERROR';
export const GET_INVOICE_SUCCESS = 'GET_INVOICE_SUCCESS';

export const GET_TRANSACTION = 'GET_TRANSACTION';
export const GET_TRANSACTION_ERROR = 'GET_TRANSACTION_ERROR';
export const GET_TRANSACTION_SUCCESS = 'GET_TRANSACTION_SUCCESS';

export const SAVE_TRANSACTION = 'SAVE_TRANSACTION';
export const SAVE_TRANSACTION_ERROR = 'SAVE_TRANSACTION_ERROR';
export const SAVE_TRANSACTION_SUCCESS = 'SAVE_TRANSACTION_SUCCESS';

export const DUPLICATE_TRANSACTION = 'DUPLICATE_TRANSACTION';
export const DUPLICATE_TRANSACTION_ERROR = 'DUPLICATE_TRANSACTION_ERROR';
export const DUPLICATE_TRANSACTION_SUCCESS = 'DUPLICATE_TRANSACTION_SUCCESS';

export const CHANGE_DATE_TRANSACTION = 'CHANGE_DATE_TRANSACTION';
export const CHANGE_DATE_TRANSACTION_ERROR = 'CHANGE_DATE_TRANSACTION_ERROR';
export const CHANGE_DATE_TRANSACTION_SUCCESS = 'CHANGE_DATE_TRANSACTION_SUCCESS';

export const MASS_DELETE_TRANSACTION = 'MASS_DELETE_TRANSACTION';
export const MASS_DELETE_TRANSACTION_ERROR = 'MASS_DELETE_TRANSACTION_ERROR';
export const MASS_DELETE_TRANSACTION_SUCCESS = 'MASS_DELETE_TRANSACTION_SUCCESS';

export const TRANSFER_TRANSACTION = 'TRANSFER_TRANSACTION';
export const TRANSFER_TRANSACTION_ERROR = 'CREATE_TRANSACTIONS';
export const TRANSFER_TRANSACTION_SUCCESS = 'TRANSFER_TRANSACTION_SUCCESS';

export const GET_ACCOUNTS_WITH_TOTAL = 'GET_ACCOUNTS_WITH_TOTAL';
export const GET_ACCOUNTS_WITH_TOTAL_ERROR = 'GET_ACCOUNTS_WITH_TOTAL_ERROR';
export const GET_ACCOUNTS_WITH_TOTAL_SUCCESS = 'GET_ACCOUNTS_WITH_TOTAL_SUCCESS';

export const CREATE_TRANSACTIONS = 'CREATE_TRANSACTIONS';
export const CREATE_TRANSACTIONS_ERROR = 'CREATE_TRANSACTIONS_ERROR';
export const CREATE_TRANSACTIONS_SUCCESS = 'CREATE_TRANSACTIONS_SUCCESS';

export const UPDATE_COOWNER_CONTACT = 'UPDATE_COOWNER_CONTACT';
export const UPDATE_COOWNER_CONTACT_ERROR = 'UPDATE_COOWNER_CONTACT_ERROR';
export const UPDATE_COOWNER_CONTACT_SUCCESS = 'UPDATE_COOWNER_CONTACT_SUCCESS';

export const CREATE_PAYMENT_TRANSACTION = 'CREATE_PAYMENT_TRANSACTION';
export const CREATE_PAYMENT_TRANSACTION_ERROR = 'CREATE_PAYMENT_TRANSACTION_ERROR';
export const CREATE_PAYMENT_TRANSACTION_SUCCESS = 'CREATE_PAYMENT_TRANSACTION_SUCCESS';

export const GET_TRANSACTION_USER = 'GET_TRANSACTION_USER';
export const GET_TRANSACTION_USER_ERROR = 'GET_TRANSACTION_USER_ERROR';
export const GET_TRANSACTION_USER_SUCCESS = 'GET_TRANSACTION_USER_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Transactions/constants.js